import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import MapSidebar from './components/MapSidebar';
import FarmMap from './components/FarmMap';
import { useLanguage } from '../../contexts/LanguageContext';

const InteractiveFarmMap = () => {
  const { language } = useLanguage();
  const [selectedFarm, setSelectedFarm] = useState(null);
  const [filters, setFilters] = useState({
    countries: [],
    elevation: { min: '', max: '' },
    certifications: []
  });

  const handleFarmSelect = (farm) => {
    setSelectedFarm(farm);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const pageTitle = language === 'en' ?'Interactive Farm Map - Africoffee' :'互动农场地图 - Africoffee';
  
  const pageDescription = language === 'en' ?'Explore African coffee farm locations with interactive geospatial visualization. View farm boundaries, altitude data, and certifications across Ethiopia, Uganda, Kenya, and Nigeria.' :'通过互动地理空间可视化探索非洲咖啡农场位置。查看埃塞俄比亚、乌干达、肯尼亚和尼日利亚的农场边界、海拔数据和认证。';

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-[60px] h-screen">
          <div className="flex h-[calc(100vh-60px)]">
            <MapSidebar
              language={language}
              onFarmSelect={handleFarmSelect}
              selectedFarm={selectedFarm}
              onFilterChange={handleFilterChange}
            />
            
            <div className="flex-1">
              <FarmMap
                language={language}
                selectedFarm={selectedFarm}
                filters={filters}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default InteractiveFarmMap;